var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-body"},[_c('div',{staticClass:"app-body",attrs:{"ui-view":"","id":"view"}},[_c(_vm.component,{tag:"component",attrs:{"board-title":"공지사항","board-name":"notice"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }